(function () {
  const STORAGE_KEY = 'comparedProducts';
  const MIN_PRODUCTS = 2;
  const MAX_PRODUCTS = 3;

  const parseStoredProducts = () => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  const persistProducts = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(window.comparedProducts));
    } catch {
      /* ignore quota errors */
    }
  };

  if (!Array.isArray(window.comparedProducts)) {
    window.comparedProducts = parseStoredProducts();
  }

  const getBar = () => document.querySelector('[data-collection-compare-bar]');

  const getProductFromElement = (element) => {
    const card = element.closest('[data-compare-product]');
    if (!card) return null;

    const id = Number(card.dataset.productId);
    if (!id) return null;

    return {
      id,
      name: card.dataset.productTitle || '',
      image: card.dataset.productImage || '',
      url: card.dataset.productUrl || '',
    };
  };

  const syncCheckbox = (card) => {
    const input = card.querySelector('.card-compare__input');
    if (!input) return;

    const id = Number(card.dataset.productId);
    const isCompared = window.comparedProducts.some((product) => product.id === id);
    input.checked = isCompared;
    card.classList.toggle('is-compared', isCompared);
  };

  const syncAllCheckboxes = () => {
    document.querySelectorAll('[data-compare-product]').forEach(syncCheckbox);
  };

  const renderBar = () => {
    const bar = getBar();
    if (!bar) return;

    const products = window.comparedProducts;
    const slots = bar.querySelectorAll('[data-compare-slot]');
    const compareButton = bar.querySelector('[data-compare-submit]');
    const countLabel = bar.querySelector('[data-compare-count]');

    bar.hidden = products.length === 0;
    document.documentElement.classList.toggle('collection-compare-active', products.length > 0);

    slots.forEach((slot, index) => {
      const product = products[index];
      const image = slot.querySelector('[data-compare-slot-image]');
      const title = slot.querySelector('[data-compare-slot-title]');
      const removeButton = slot.querySelector('[data-compare-slot-remove]');
      const placeholder = slot.querySelector('[data-compare-slot-placeholder]');

      if (!product) {
        slot.classList.remove('is-filled');
        slot.classList.add('is-empty');
        if (image) {
          image.removeAttribute('src');
          image.alt = '';
          image.hidden = true;
        }
        if (title) title.textContent = '';
        if (removeButton) removeButton.hidden = true;
        if (placeholder) placeholder.hidden = false;
        return;
      }

      slot.classList.add('is-filled');
      slot.classList.remove('is-empty');
      if (placeholder) placeholder.hidden = true;
      if (image) {
        if (product.image) {
          image.src = product.image;
          image.alt = product.name;
          image.hidden = false;
        } else {
          image.hidden = true;
        }
      }
      if (title) title.textContent = product.name;
      if (removeButton) {
        removeButton.hidden = false;
        removeButton.dataset.productId = String(product.id);
      }
    });

    if (countLabel) {
      countLabel.textContent = `${products.length}/${MAX_PRODUCTS}`;
    }

    if (compareButton) {
      compareButton.setAttribute('aria-disabled', products.length >= MIN_PRODUCTS ? 'false' : 'true');
    }
  };

  const showLimitMessage = () => {
    const message = getBar()?.dataset.limitMessage;
    if (message) window.alert(message);
  };

  const addProduct = (product) => {
    if (!product || window.comparedProducts.some((item) => item.id === product.id)) return;

    if (window.comparedProducts.length >= MAX_PRODUCTS) {
      showLimitMessage();
      return;
    }

    window.comparedProducts = [...window.comparedProducts, product];
    persistProducts();
    syncAllCheckboxes();
    renderBar();
  };

  const removeProduct = (productId) => {
    window.comparedProducts = window.comparedProducts.filter((product) => product.id !== productId);
    persistProducts();
    syncAllCheckboxes();
    renderBar();
  };

  const toggleProduct = (product, shouldCompare) => {
    if (shouldCompare) {
      addProduct(product);
      return;
    }
    removeProduct(product.id);
  };

  const handleCompareToggle = (input) => {
    const product = getProductFromElement(input);
    if (!product) return;

    if (
      input.checked &&
      window.comparedProducts.length >= MAX_PRODUCTS &&
      !window.comparedProducts.some((item) => item.id === product.id)
    ) {
      input.checked = false;
      showLimitMessage();
      return;
    }

    toggleProduct(product, input.checked);
  };

  const openCompareModal = () => {
    if (window.comparedProducts.length < MIN_PRODUCTS) return;

    persistProducts();
    window.dispatchEvent(new CustomEvent('collection-compare:open'));
  };

  const onDocumentClick = (event) => {
    const compareControl = event.target.closest('.card-compare');
    if (compareControl) {
      event.preventDefault();
      event.stopPropagation();

      const input = compareControl.querySelector('.card-compare__input');
      if (!input) return;

      input.checked = !input.checked;
      handleCompareToggle(input);
      return;
    }

    const removeButton = event.target.closest('[data-compare-slot-remove]');
    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();
      removeProduct(Number(removeButton.dataset.productId));
      return;
    }

    const compareButton = event.target.closest('[data-compare-submit]');
    if (compareButton) {
      event.preventDefault();
      event.stopPropagation();
      if (compareButton.getAttribute('aria-disabled') === 'true') return;
      openCompareModal();
    }
  };

  const init = () => {
    syncAllCheckboxes();
    renderBar();
    document.addEventListener('click', onDocumentClick, true);
    document.addEventListener('collection:product-grid-updated', () => {
      syncAllCheckboxes();
      renderBar();
    });
  };

  window.CollectionCompare = {
    addProduct,
    removeProduct,
    toggleProduct,
    syncAllCheckboxes,
    renderBar,
    openCompareModal,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
